import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { permissionService } from "../../services/PermissionService";
import FunctionalitySet from "./FunctionalitySet";

export default function EditRolePermission(props) {
  let history = useHistory();
  const [rolePermissions, setRolePermission] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    permissionService
      .getRolePermissions(props.match.params.roleId)
      .then((data) => setRolePermission(data));
  }, []);

  function save() {
    let functionalities = [];
    for (let key in rolePermissions.functionalities) {
      for (let item of rolePermissions.functionalities[key]) {
        if (item.selected) functionalities.push(item.id);
      }
    }
    permissionService
      .saveRoleFunctionalities(props.match.params.roleId, functionalities)
      .then(() => toast.success(t("Functionality changed successfully")));
  }

  function changeFunctionality(event, functionalityId, setName) {
    var index = rolePermissions.functionalities[setName]
      .map((x) => x.id)
      .indexOf(functionalityId);
    let _userpermissions = { ...rolePermissions };
    _userpermissions.functionalities[setName][index].selected =
      event.target.checked;
    setRolePermission(_userpermissions);
  }

  return (
    <>
      <div className="row m-2">
        <div className="col">
          <p> {t(rolePermissions.name)}</p>
          <p> {t(rolePermissions.description)}</p>
        </div>
        <div className="col text-end">
          <button
            className="btn app-button btn-second btn-lg"
            onClick={() => history.push("/Permissions")}
          >
            {t("Cancel")}
          </button>
          <button className="app-button btn-prime btn-lg" onClick={save}>
            {t("Save")}
          </button>
        </div>
      </div>
      <div class="accordion" id="functionalities">
        {rolePermissions.functionalities &&
          Object.keys(rolePermissions.functionalities).map((key) => (
            <FunctionalitySet
              funtionalities={rolePermissions.functionalities[key]}
              functionalitySetName={key}
              changeFunctionality={changeFunctionality}
            />
          ))}
      </div>
    </>
  );
}
